/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://fqgynxpvorhbhdtvz4avdsmjeq.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-qxonpdjvnzghpecetrwmdxbiyu",
    "aws_cognito_identity_pool_id": "us-east-1:f6c7bb78-06be-47f1-aacf-b13d39eacd5a",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_DOqED6jDk",
    "aws_user_pools_web_client_id": "4ejk8qvg491qp8iu9slm4166rn",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "nexaadmin523ac9c95e87447389804b606f598c57cac63-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
